const B = [
  "intake",
  "classification",
  "grading",
  "scoring",
  "reporting"
], x = {
  intake: 15,
  classification: 10,
  grading: 65,
  scoring: 5,
  reporting: 5
}, h = ["started", "completed", "failed"], m = [
  "reading",
  "read",
  "classified",
  "grading",
  "graded",
  "failed"
], W = 15 * 60 * 1e3, X = 10 * 60 * 1e3, k = [
  "unreadable",
  "empty",
  "extraction_failed",
  "grading_failed",
  "unknown"
];
var T = /* @__PURE__ */ ((E) => (E.EN = "en", E.AR = "ar", E))(T || {});
const b = [
  "en",
  "ar"
  /* AR */
], w = {
  en: "English",
  ar: "Arabic"
};
var D = /* @__PURE__ */ ((E) => (E.TODAY = "today", E.THIS_WEEK = "this_week", E.THIS_MONTH = "this_month", E.THIS_QUARTER = "this_quarter", E))(D || {}), R = /* @__PURE__ */ ((E) => (E[E.TEN = 10] = "TEN", E[E.TWENTY = 20] = "TWENTY", E[E.FIFTY = 50] = "FIFTY", E[E.ONE = 1] = "ONE", E))(R || {}), L = /* @__PURE__ */ ((E) => (E.ASC = "ASC", E.DESC = "DESC", E))(L || {}), e = /* @__PURE__ */ ((E) => (E.LESS_THAN = "<", E.LESS_THAN_OR_EQUAL_TO = "<=", E.GREATER_THAN = ">", E.GREATER_THAN_OR_EQUAL_TO = ">=", E.EQUAL_TO = "=", E.NOT_EQUAL_TO = "!=", E))(e || {});
const Q = "__STREAMING_CHUNK_DELIMITER__", $ = "auth.userProfile", u = "komplyance.localStorage", j = [T.EN, T.AR], y = 255, Z = ["title", "status", "score", "updatedAt"];
var M = /* @__PURE__ */ ((E) => (E.SINGLE = "SINGLE", E.MULTI = "MULTI", E))(M || {}), U = /* @__PURE__ */ ((E) => (E.DRAFT = "draft", E.SUBMITTED = "submitted", E.PROCESSING = "processing", E.COMPLETED = "completed", E.FAILED = "failed", E))(U || {}), n = /* @__PURE__ */ ((E) => (E.NOT_STARTED = "not_started", E.IN_PROGRESS = "in_progress", E.COMPLETED = "completed", E))(n || {}), r = /* @__PURE__ */ ((E) => (E.PENDING = "pending", E.CONFIRMED = "confirmed", E))(r || {}), C = /* @__PURE__ */ ((E) => (E.HIGH = "high", E.MEDIUM = "medium", E.LOW = "low", E))(C || {}), c = /* @__PURE__ */ ((E) => (E.PENDING = "classification_pending", E.PROCESSING = "classification_processing", E.COMPLETED = "classification_completed", E.FAILED = "classification_failed", E))(c || {}), a = /* @__PURE__ */ ((E) => (E.WRONG_DOMAIN = "wrong_domain", E.NO_MATCH = "no_match", E.WRONG_FORMAT = "wrong_format", E.UNSUPPORTED_FORMAT = "unsupported_format", E.WEAK_MATCH = "weak_match", E))(a || {}), F = /* @__PURE__ */ ((E) => (E.FULL = "full", E.PARTIAL = "partial", E.MINIMAL = "minimal", E))(F || {}), d = /* @__PURE__ */ ((E) => (E.HEALTH = "health", E.FINANCE = "finance", E.DEFAULT = "default", E))(d || {}), o = /* @__PURE__ */ ((E) => (E.DOCUMENT = "document", E.CHECKMARK = "checkmark", E.TEXT = "text", E.TEXTAREA = "textarea", E.RADIO = "radio", E.SELECT = "select", E))(o || {}), P = /* @__PURE__ */ ((E) => (E.PDPL = "pdpl", E))(P || {}), A = /* @__PURE__ */ ((E) => (E.ABSENCE_OF_CAPABILITIES = "absenceOfCapabilities", E.ESTABLISHING = "establishing", E.DEFINED = "defined", E.ACTIVATED = "activated", E.MANAGED = "managed", E.PIONEER = "pioneer", E))(A || {}), G = /* @__PURE__ */ ((E) => (E.CRITICAL = "critical", E.MEDIUM = "medium", E.LOW = "low", E))(G || {});
const z = {
  [A.ABSENCE_OF_CAPABILITIES]: {
    key: A.ABSENCE_OF_CAPABILITIES,
    label: {
      en: "Absence of Capabilities",
      ar: "غياب القدرات"
    },
    level: 0,
    percentage: { min: 0, max: 4.9 },
    score: { min: 0, max: 0.24 },
    color: {
      hex: "#E84749",
      themeVar: "red.500"
    }
  },
  [A.ESTABLISHING]: {
    key: A.ESTABLISHING,
    label: {
      en: "Establishing",
      ar: "البناء"
    },
    level: 1,
    percentage: { min: 5, max: 24.9 },
    score: { min: 0.25, max: 1.24 },
    color: {
      hex: "#E87040",
      themeVar: "orange.500"
    }
  },
  [A.DEFINED]: {
    key: A.DEFINED,
    label: {
      en: "Defined",
      ar: "التعريف"
    },
    level: 2,
    percentage: { min: 25, max: 49.9 },
    score: { min: 1.25, max: 2.49 },
    color: {
      hex: "#1960DC",
      themeVar: "blue.800"
    }
  },
  [A.ACTIVATED]: {
    key: A.ACTIVATED,
    label: {
      en: "Activated",
      ar: "التفعيل"
    },
    level: 3,
    percentage: { min: 50, max: 79.9 },
    score: { min: 2.5, max: 3.99 },
    color: {
      hex: "#3795FA",
      themeVar: "blue.600"
    }
  },
  [A.MANAGED]: {
    key: A.MANAGED,
    label: {
      en: "Managed",
      ar: "التمكن"
    },
    level: 4,
    percentage: { min: 80, max: 94.9 },
    score: { min: 4, max: 4.74 },
    color: {
      hex: "#1B9E5C",
      themeVar: "green.700"
    }
  },
  [A.PIONEER]: {
    key: A.PIONEER,
    label: {
      en: "Pioneer",
      ar: "الريادة"
    },
    level: 5,
    percentage: { min: 95, max: 100 },
    score: { min: 4.75, max: 5 },
    color: {
      hex: "#6F9412",
      themeVar: "vividGreen.700"
    }
  }
};
var p = /* @__PURE__ */ ((E) => (E.PENDING = "pending", E.PROCESSING = "processing", E.READY_FOR_REVIEW = "ready_for_review", E.FINALIZING = "finalizing", E.COMPLETED = "completed", E.DISCARDED = "discarded", E.FAILED = "failed", E))(p || {});
const q = [
  "pending",
  "processing",
  "ready_for_review",
  "finalizing"
  /* FINALIZING */
], J = [
  "pending",
  "processing",
  "finalizing"
  /* FINALIZING */
], EE = [
  "completed",
  "discarded",
  "failed"
  /* FAILED */
], AE = [
  "pending",
  "processing",
  "ready_for_review"
  /* READY_FOR_REVIEW */
];
var l = /* @__PURE__ */ ((E) => (E.PENDING = "pending", E.PROCESSING = "processing", E.REVIEW_PENDING = "review_pending", E.ACCEPTED = "accepted", E.REJECTED = "rejected", E.NO_CHANGES = "no_changes", E.FAILED = "failed", E))(l || {});
const _E = [
  "accepted",
  "rejected",
  "no_changes",
  "failed"
  /* FAILED */
], NE = [
  "pending",
  "processing",
  "no_changes",
  "failed"
  /* FAILED */
];
var g = /* @__PURE__ */ ((E) => (E.GENERATE = "GENERATE", E.REMEDIATE = "REMEDIATE", E))(g || {}), s = /* @__PURE__ */ ((E) => (E.PROSE = "PROSE", E.SPREADSHEET = "SPREADSHEET", E))(s || {}), i = /* @__PURE__ */ ((E) => (E.PENDING = "PENDING", E.ACCEPTED = "ACCEPTED", E.REJECTED = "REJECTED", E))(i || {});
const IE = 100;
var t = /* @__PURE__ */ ((E) => (E.NONE = "none", E.IN_PROGRESS = "inProgress", E.FULL = "full", E))(t || {});
const TE = Symbol("S3_CLIENT"), SE = 300, OE = 3600, H = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i, _ = "[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}", DE = new RegExp(
  `^tenants/(${_})/documents/(${_}\\.[a-zA-Z0-9]+)$`,
  "i"
), RE = new RegExp(
  `^tenants/(${_})/assessments/(${_})/domains/(${_})/documents/(${_}\\.[a-zA-Z0-9]+)$`,
  "i"
), LE = new RegExp(
  `^tenants/(${_})/users/(${_})/conversations/([^/]+)/documents/(${_}\\.[a-zA-Z0-9]+)$`,
  "i"
), eE = /^\+?(?:[\s().-]*\d){7,15}[\s().-]*$/, ME = "+966 50 123 4567", UE = {
  /**
   * Check if a string is a valid UUID
   * @param value - The string to validate
   * @returns True if the string is a valid UUID
   */
  isUUID: (E) => H.test(E),
  /**
   * Check if a string is a valid positive integer
   * @param value - The string to validate
   * @returns True if the string is a valid positive integer
   */
  isPositiveInteger: (E) => {
    const N = parseInt(E, 10);
    return !isNaN(N) && N >= 0 && N.toString() === E;
  }
}, S = [
  "application/pdf",
  "text/plain",
  // Word
  "application/msword",
  // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  // .docx
  // Excel
  "application/vnd.ms-excel",
  // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  // .xlsx
], nE = [
  ...S,
  "image/png",
  "image/jpeg"
], rE = [
  ...S,
  "image/png",
  "image/jpeg"
], CE = {
  "application/pdf": [".pdf"],
  "text/plain": [".txt"],
  "application/msword": [".doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"]
}, cE = [
  ".pdf",
  ".txt",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".png",
  ".jpg",
  ".jpeg"
], aE = 10 * 1024 * 1024, FE = 255, dE = {
  COMMON: {
    NOT_FOUND: "COMMON.NOT_FOUND",
    INTERNAL_ERROR: "COMMON.INTERNAL_ERROR",
    VALIDATION_ERROR: "COMMON.VALIDATION_ERROR",
    UNAUTHORIZED: "COMMON.UNAUTHORIZED",
    FORBIDDEN: "COMMON.FORBIDDEN",
    /** Rate limited. Raised by the global ThrottlerGuard (429). */
    TOO_MANY_REQUESTS: "COMMON.TOO_MANY_REQUESTS"
  },
  ASSESSMENT: {
    NOT_FOUND: "ASSESSMENT.NOT_FOUND",
    INVALID_STATUS: "ASSESSMENT.INVALID_STATUS",
    UNSUPPORTED_LANGUAGE: "ASSESSMENT.UNSUPPORTED_LANGUAGE",
    CREATION_FAILED: "ASSESSMENT.CREATION_FAILED",
    DUPLICATION_FAILED: "ASSESSMENT.DUPLICATION_FAILED",
    STATUS_CHECK_FAILED: "ASSESSMENT.STATUS_CHECK_FAILED",
    AI_RESPONSE_INVALID: "ASSESSMENT.AI_RESPONSE_INVALID",
    DOMAINS_INCOMPLETE: "ASSESSMENT.DOMAINS_INCOMPLETE",
    HAS_PENDING_DOCUMENTS: "ASSESSMENT.HAS_PENDING_DOCUMENTS",
    NO_VALID_DOCUMENTS: "ASSESSMENT.NO_VALID_DOCUMENTS",
    HAS_ACTIVE_DRAFT_VERSION: "ASSESSMENT.HAS_ACTIVE_DRAFT_VERSION",
    VERSION_CREATION_FAILED: "ASSESSMENT.VERSION_CREATION_FAILED",
    NOT_LATEST_VERSION: "ASSESSMENT.NOT_LATEST_VERSION",
    NOT_SAME_PARENT: "ASSESSMENT.NOT_SAME_PARENT",
    ONLY_ROOT_DELETABLE: "ASSESSMENT.ONLY_ROOT_DELETABLE",
    HAS_ACTIVE_REMEDIATION_RUN: "ASSESSMENT.HAS_ACTIVE_REMEDIATION_RUN"
  },
  REMEDIATION: {
    NOT_FOUND: "REMEDIATION.NOT_FOUND",
    INVALID_STATUS: "REMEDIATION.INVALID_STATUS",
    ITEM_NOT_FOUND: "REMEDIATION.ITEM_NOT_FOUND",
    INVALID_ITEM_TYPE: "REMEDIATION.INVALID_ITEM_TYPE",
    INVALID_ITEM_STATUS: "REMEDIATION.INVALID_ITEM_STATUS",
    CHANGE_NOT_FOUND: "REMEDIATION.CHANGE_NOT_FOUND",
    ITEMS_NOT_ALL_REVIEWED: "REMEDIATION.ITEMS_NOT_ALL_REVIEWED",
    HAS_ACTIVE_RUN: "REMEDIATION.HAS_ACTIVE_RUN",
    NO_GAPS_TO_REMEDIATE: "REMEDIATION.NO_GAPS_TO_REMEDIATE",
    CREATION_FAILED: "REMEDIATION.CREATION_FAILED",
    /**
     * The worker asking for work has been replaced. Answered with 410, which
     * the Job reads as "stop, cleanly" rather than as an error to retry.
     */
    WORKER_SUPERSEDED: "REMEDIATION.WORKER_SUPERSEDED"
  },
  FRAMEWORK: {
    NOT_FOUND: "FRAMEWORK.NOT_FOUND",
    NO_DOMAINS: "FRAMEWORK.NO_DOMAINS",
    NO_IDENTIFIER: "FRAMEWORK.NO_IDENTIFIER"
  },
  AUTH: {
    TENANT_REQUIRED: "AUTH.TENANT_REQUIRED",
    NO_TENANT_ASSIGNED: "AUTH.NO_TENANT_ASSIGNED"
  },
  FEATURE: {
    /** The requested feature is disabled for this tenant/environment. */
    DISABLED: "FEATURE.DISABLED"
  },
  USAGE: {
    /** `from` is after `to`, or a date failed to parse. */
    INVALID_DATE_RANGE: "USAGE.INVALID_DATE_RANGE",
    /** Range exceeds USAGE_RANGE_MAX_DAYS — refuse rather than scan years of rollup. */
    RANGE_TOO_LARGE: "USAGE.RANGE_TOO_LARGE"
  },
  ADMIN: {
    USER_NOT_FOUND: "ADMIN.USER_NOT_FOUND",
    TENANT_NOT_FOUND: "ADMIN.TENANT_NOT_FOUND",
    ROLE_NOT_FOUND: "ADMIN.ROLE_NOT_FOUND",
    USER_DISABLED: "ADMIN.USER_DISABLED",
    LAST_ADMIN: "ADMIN.LAST_ADMIN",
    CANNOT_SELF_REVOKE: "ADMIN.CANNOT_SELF_REVOKE",
    TENANT_ALREADY_EXISTS: "ADMIN.TENANT_ALREADY_EXISTS",
    USER_ALREADY_EXISTS: "ADMIN.USER_ALREADY_EXISTS",
    MEMBERSHIP_NOT_FOUND: "ADMIN.MEMBERSHIP_NOT_FOUND"
  },
  S3: {
    DELETE_FAILED: "S3.DELETE_FAILED",
    UPLOAD_URL_GENERATION_FAILED: "S3.UPLOAD_URL_GENERATION_FAILED",
    DOWNLOAD_URL_GENERATION_FAILED: "S3.DOWNLOAD_URL_GENERATION_FAILED",
    FILE_NOT_FOUND: "S3.FILE_NOT_FOUND",
    METADATA_CHECK_FAILED: "S3.METADATA_CHECK_FAILED",
    LIST_FAILED: "S3.LIST_FAILED",
    BATCH_DELETE_FAILED: "S3.BATCH_DELETE_FAILED",
    DOWNLOAD_FAILED: "S3.DOWNLOAD_FAILED",
    UPLOAD_FAILED: "S3.UPLOAD_FAILED",
    COPY_FAILED: "S3.COPY_FAILED"
  },
  KOMPLYANCE_AI: {
    BAD_REQUEST: "komplyance_AI.BAD_REQUEST",
    NOT_FOUND: "komplyance_AI.NOT_FOUND",
    AUTHENTICATION_FAILED: "komplyance_AI.AUTHENTICATION_FAILED",
    RATE_LIMIT_EXCEEDED: "komplyance_AI.RATE_LIMIT_EXCEEDED",
    CIRCUIT_BREAKER_OPEN: "komplyance_AI.CIRCUIT_BREAKER_OPEN",
    SERVICE_UNAVAILABLE: "komplyance_AI.SERVICE_UNAVAILABLE",
    INTERNAL_ERROR: "komplyance_AI.INTERNAL_ERROR",
    PARSE_ERROR: "komplyance_AI.PARSE_ERROR"
  },
  DOCUMENT: {
    NOT_FOUND: "DOCUMENT.NOT_FOUND",
    S3_FILE_NOT_FOUND: "DOCUMENT.S3_FILE_NOT_FOUND",
    ALREADY_EXISTS: "DOCUMENT.ALREADY_EXISTS",
    DOMAIN_STATUS_INVALID: "DOCUMENT.DOMAIN_STATUS_INVALID",
    ASSESSMENT_STATUS_INVALID: "DOCUMENT.ASSESSMENT_STATUS_INVALID",
    INVALID_S3_KEY: "DOCUMENT.INVALID_S3_KEY",
    INVALID_FORMAT: "DOCUMENT.INVALID_FORMAT",
    SIZE_EXCEEDED: "DOCUMENT.SIZE_EXCEEDED",
    CLASSIFICATION_IN_PROGRESS: "DOCUMENT.CLASSIFICATION_IN_PROGRESS",
    /**
     * The four ways a document can collide with one already in a domain.
     *
     * Distinct codes because the front end shows the *code's* translation and
     * never the message the service wrote — so a plain `BadRequestException`
     * here reaches the user as "Validation error. Please check your input.",
     * which describes neither what happened nor what to do about it. Each of
     * these has a different remedy, and the user cannot choose one without
     * being told which they hit.
     */
    DUPLICATE_FILE_IN_DOMAIN: "DOCUMENT.DUPLICATE_FILE_IN_DOMAIN",
    DUPLICATE_FILE_IN_TARGET_DOMAIN: "DOCUMENT.DUPLICATE_FILE_IN_TARGET_DOMAIN",
    ALREADY_IN_TARGET_DOMAIN: "DOCUMENT.ALREADY_IN_TARGET_DOMAIN",
    STANDARD_DOCUMENT_TAKEN: "DOCUMENT.STANDARD_DOCUMENT_TAKEN"
  },
  DOMAIN: {
    NOT_FOUND: "DOMAIN.NOT_FOUND",
    NOT_IN_PROGRESS: "DOMAIN.NOT_IN_PROGRESS",
    HAS_PENDING_CHANGES: "DOMAIN.HAS_PENDING_CHANGES",
    VALIDATION_FAILED: "DOMAIN.VALIDATION_FAILED",
    CANNOT_START: "DOMAIN.CANNOT_START",
    STATUS_TRANSITION_FAILED: "DOMAIN.STATUS_TRANSITION_FAILED",
    RELOAD_FAILED: "DOMAIN.RELOAD_FAILED",
    APPLICABILITY_REQUIRED: "DOMAIN.APPLICABILITY_REQUIRED",
    REQUIRED_NOT_INAPPLICABLE: "DOMAIN.REQUIRED_NOT_INAPPLICABLE",
    INAPPLICABLE_HAS_DOCUMENTS: "DOMAIN.INAPPLICABLE_HAS_DOCUMENTS",
    INAPPLICABLE_AND_SKIPPED: "DOMAIN.INAPPLICABLE_AND_SKIPPED",
    SKIPPED_HAS_DOCUMENTS: "DOMAIN.SKIPPED_HAS_DOCUMENTS",
    DOCUMENTS_REQUIRED: "DOMAIN.DOCUMENTS_REQUIRED",
    DOCUMENTS_NOT_ACCEPTED: "DOMAIN.DOCUMENTS_NOT_ACCEPTED",
    DOCUMENTS_NOT_CLASSIFIED: "DOMAIN.DOCUMENTS_NOT_CLASSIFIED",
    DOCUMENTS_CLASSIFICATION_FAILED: "DOMAIN.DOCUMENTS_CLASSIFICATION_FAILED",
    DOCUMENTS_INVALID_CLASSIFICATION: "DOMAIN.DOCUMENTS_INVALID_CLASSIFICATION",
    DOCUMENTS_EXCEEDS_MAXIMUM: "DOMAIN.DOCUMENTS_EXCEEDS_MAXIMUM",
    DOCUMENTS_DUPLICATE_CLASSIFICATION: "DOMAIN.DOCUMENTS_DUPLICATE_CLASSIFICATION"
  },
  KEYCLOAK: {
    TOKEN_EXCHANGE_FAILED: "KEYCLOAK.TOKEN_EXCHANGE_FAILED",
    TOKEN_REFRESH_FAILED: "KEYCLOAK.TOKEN_REFRESH_FAILED",
    USER_INFO_FAILED: "KEYCLOAK.USER_INFO_FAILED",
    LOGOUT_FAILED: "KEYCLOAK.LOGOUT_FAILED",
    SERVICE_UNAVAILABLE: "KEYCLOAK.SERVICE_UNAVAILABLE"
  }
};
var V = /* @__PURE__ */ ((E) => (E.QUEUED = "queued", E.UPLOADING = "uploading", E.NOT_SAVED = "notSaved", E.UPLOADED = "uploaded", E.FAILED = "failed", E.PENDING_DELETE = "pendingDelete", E.DELETING = "deleting", E.DELETED = "deleted", E.DELETE_FAILED = "deleteFailed", E))(V || {}), f = /* @__PURE__ */ ((E) => (E.PENDING = "pending", E.PROCESSING = "processing", E.COMPLETED = "completed", E.FAILED = "failed", E))(f || {}), Y = /* @__PURE__ */ ((E) => (E.NOT_STARTED = "not_started", E.QUEUED = "queued", E.PROCESSING = "processing", E.EXTRACTED = "extracted", E.FAILED = "failed", E.PUBLISHED = "published", E))(Y || {}), K = /* @__PURE__ */ ((E) => (E.CLASSIFYING = "classifying", E.INVALID = "invalid", E.READY_TO_EXTRACT = "ready_to_extract", E.EXTRACTING = "extracting", E.PENDING_REVIEW = "pending_review", E.DONE = "done", E.FAILED = "failed", E))(K || {});
function oE(E) {
  const { classification: N, verdict: O, extraction: I } = E;
  if (I === "published")
    return "done";
  if (N === "failed" || I === "failed")
    return "failed";
  if (N === "pending" || N === "processing")
    return "classifying";
  if (O !== "valid")
    return "invalid";
  switch (I) {
    case "queued":
    case "processing":
      return "extracting";
    case "extracted":
      return "pending_review";
    case "not_started":
    default:
      return "ready_to_extract";
  }
}
const PE = {
  PLATFORM_ADMIN: "platform_admin"
}, GE = {
  REMEDIATION: "remediation",
  ASSESSMENT_PROGRESS: "assessment_progress"
}, pE = {
  LLM: "llm",
  EMBEDDING: "embedding",
  RERANK: "rerank",
  COMPUTE: "compute"
}, lE = {
  CHAT: "chat",
  DEEP_RESEARCH: "deep_research",
  ASSESSMENT: "assessment",
  DOCUMENT_GENERATION: "document_generation",
  TENANT_PROFILE: "tenant_profile",
  TRANSLATION: "translation",
  /** Our own tooling spend (Streamlit, catalog builder, ingest) — not a tenant's. */
  PLATFORM_TOOLING: "platform_tooling",
  UNKNOWN: "unknown"
}, gE = {
  PROVIDER: "provider",
  RATE_CARD: "rate_card",
  UNKNOWN: "unknown"
}, v = {
  /** Attribution bug. Should trend to zero; visible on the dashboard until it does. */
  UNKNOWN: "__unknown__",
  /** Legitimate internal spend that is ours, not a tenant's. */
  PLATFORM: "__platform__"
};
function sE(E) {
  return Object.values(v).includes(E);
}
const iE = "Asia/Riyadh", tE = 366, HE = 8, VE = {
  TODAY: "today",
  LAST_7D: "7d",
  LAST_30D: "30d",
  MONTH_TO_DATE: "mtd",
  PREVIOUS_MONTH: "prev-month"
};
export {
  q as ACTIVE_REMEDIATION_RUN_STATUSES,
  nE as ALLOWED_CONTENT_TYPES,
  S as ALLOWED_DOCUMENT_CONTENT_TYPES,
  rE as ALLOWED_REFERENCE_CONTENT_TYPES,
  cE as ALLOWED_REFERENCE_FORMATS,
  Z as ASSESSMENTS_SORT_BY_TYPES,
  k as ASSESSMENT_DOCUMENT_FAILURE_REASONS,
  m as ASSESSMENT_DOCUMENT_PROGRESS_STATES,
  RE as ASSESSMENT_DOC_S3_KEY_REGEX,
  W as ASSESSMENT_PROGRESS_STALL_THRESHOLD_MS,
  X as ASSESSMENT_PROGRESS_STARTUP_GRACE_MS,
  B as ASSESSMENT_STAGE_KEYS,
  h as ASSESSMENT_STAGE_PROGRESS_STATES,
  x as ASSESSMENT_STAGE_WEIGHTS,
  r as AssessmentDocumentStatus,
  n as AssessmentDomainStatus,
  t as AssessmentRemediationState,
  U as AssessmentStatus,
  LE as CHAT_DOC_S3_KEY_REGEX,
  C as ClassificationConfidence,
  e as ComparisonOperator,
  F as DocumentClassificationCoverage,
  a as DocumentClassificationInvalidReason,
  c as DocumentClassificationStatus,
  dE as ErrorCode,
  GE as FeatureFlagKey,
  o as FieldTypeEnum,
  V as FileStatus,
  P as FrameworkKey,
  G as GapPriority,
  PE as KeycloakRealmRole,
  w as LANGUAGE_LABEL,
  T as LanguageCode,
  R as LimitPerPage,
  z as MATURITY_CONFIG,
  y as MAX_ASSESSMENT_TITLE_LENGTH,
  FE as MAX_DOCUMENT_NAME_LENGTH,
  aE as MAX_DOCUMENT_SIZE_BYTES,
  A as MaturityLevelKey,
  L as Order,
  j as PDPL_SUPPORTED_LANGUAGES,
  ME as PHONE_FORMAT_EXAMPLE,
  eE as PHONE_REGEX,
  M as ProgressFlowStepType,
  CE as REFERENCE_CONTENT_TYPE_EXTENSIONS,
  IE as REMEDIATION_MAX_SCORE,
  AE as REVIEWABLE_REMEDIATION_RUN_STATUSES,
  s as RemediationContentKind,
  i as RemediationDecision,
  l as RemediationItemStatus,
  g as RemediationItemType,
  p as RemediationRunStatus,
  TE as S3_CLIENT,
  OE as S3_DOWNLOAD_PRESIGNED_URL_EXPIRY,
  SE as S3_UPLOAD_PRESIGNED_URL_EXPIRY,
  u as STORAGE_KEY,
  Q as STREAMING_CHUNK_DELIMITER,
  b as SUPPORTED_LANGUAGES,
  d as SectorEnum,
  DE as TENANT_DOC_S3_KEY_REGEX,
  _E as TERMINAL_REMEDIATION_ITEM_STATUSES,
  EE as TERMINAL_REMEDIATION_RUN_STATUSES,
  f as TenantProfileClassificationStatus,
  K as TenantProfileDocumentStatus,
  Y as TenantProfileExtractionStatus,
  D as TimeFilter,
  NE as UNREVIEWABLE_REMEDIATION_ITEM_STATUSES,
  HE as USAGE_COST_DECIMALS,
  tE as USAGE_RANGE_MAX_DAYS,
  iE as USAGE_REPORTING_TIMEZONE,
  $ as USER_PROFILE_KEY,
  _ as UUID_PATTERN,
  H as UUID_REGEX,
  gE as UsageCostSource,
  lE as UsageFeature,
  VE as UsageRangePreset,
  pE as UsageService,
  v as UsageTenantSentinel,
  UE as ValidationHelpers,
  J as WORKING_REMEDIATION_RUN_STATUSES,
  oE as deriveTenantProfileDocumentStatus,
  sE as isUsageTenantSentinel
};
